import { useContext } from "react";
import { InputComponentRequirementDialogContext, PageNewState } from ".";

export const useInputComponentRequirementDialogState = () => {
  const { pageState, setPageState } = useContext(
    InputComponentRequirementDialogContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
